/**
 * 会员等级
 */
export const MEMBER_LEVEL = {
  FREE: 0, // 免费版
  PERSONAL: 1, // 高级版(个人版)
  TRY: 2, // 试用版
  COMPANY: 3 // 企业版
}
